export default __webpack_public_path__ + "static/subset-CoFoKak-Black-454a3b67124e44484b2e36c0c92e733b.woff";